export default "__VITE_ASSET__Df$gN_sd__"